var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "PptFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "PPT",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.7445485 12.800251q0 .250631-.082682.45217-.082682.201538-.2377118.343648-.1524455.14211-.3772381.219625-.2222088.07752-.5322676.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036174.02584-.023254.0078-.067179.01292-.041341.0078-.1059367.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036174-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214397-.04392h.715719q.1085206 0 .2067058.01033.1007692.0078.235128.03876.1369426.02842.276469.111105.1421103.0801.2402956.198954.098185.118856.1498617.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065-.074931-.136942-.1886191-.204122-.1111044-.06718-.232544-.08527-.1188559-.01809-.2325441-.01809H5.1348267v1.341005h.4004926q.2015382 0 .3333132-.05168.1343588-.05168.2247926-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM9.483401 12.800251q0 .250631-.082682.45217-.082682.201538-.2377118.343648-.1524455.14211-.3772381.219625-.2222088.07752-.5322676.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036174.02584-.023254.0078-.067179.01292-.041341.0078-.1059367.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036174-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214397-.04392h.715719q.1085206 0 .2067058.01033.1007692.0078.235128.03876.1369426.02842.276469.111105.1421103.0801.2402956.198954.098185.118856.1498617.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065-.074931-.136942-.1886191-.204122-.1111044-.06718-.232544-.08527-.1188559-.01809-.2325441-.01809H7.8736792v1.341005h.4004926q.2015382 0 .3333132-.05168.1343588-.05168.2247926-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM12.242924 12.012185q0 .04909-.0052.08527-.0052.03617-.01809.05943-.01034.02067-.02842.03101-.0155.01034-.03617.01034h-.940511v2.899049q0 .02067-.01034.03617-.01033.0155-.03617.02584-.02584.0078-.06976.01292-.04134.0078-.105937.0078-.06201 0-.105937-.0078-.04392-.0052-.06976-.01292-.02584-.01033-.03617-.02584-.01034-.0155-.01034-.03617V12.198221H9.8296334q-.020671 0-.038757-.01034-.015503-.01033-.025838-.03101-.010335-.02325-.018087-.05943-.00517-.03617-.00517-.08527 0-.04909.00517-.08527.00775-.03876.018087-.06201.010335-.02325.025838-.03359.018087-.01033.038757-.01033h2.3254406q.02067 0 .03617.01033.01809.01034.02842.03359.01292.02325.01809.06201.0052.03617.0052.08527z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.ff85c1f4c645bbccbf267cb7ec29981c.svg";
export { ForwardRef as ReactComponent };